'use client'

// === TIPOS ===
export type {
  UTMParams,
  DeviceInfo,
  VisitorInfo,
  GeoInfo,
  SessionInfo,
  ReferrerInfo,
  PreferencesInfo,
  AnalyticsData,
  PageViewData,
  EngagementData,
  ScrollData,
} from './tipos'

// === VISITANTE ===
export { gerarUUID, getVisitorId, getVisitorInfo } from './visitante'

// === DISPOSITIVO ===
export { getDeviceInfo } from './dispositivo'

// === UTM ===
export { getUTMParams } from './utm'

// === GEO ===
export { fetchGeoInfo } from './geo'

// === SESSÃO ===
export { getSessionInfo, getReferrerInfo, getPreferencesInfo } from './sessao'

// === RASTREAMENTO ===
export {
  GA4_MEASUREMENT_ID,
  enviarEventoGA4,
  trackPageView,
  initScrollTracking,
  initClickTracking,
  initFormTracking,
  initOutboundLinkTracking,
  trackEngagementOnExit,
  initEnhancedAnalytics,
  trackEvent,
  trackFormStep,
  trackFormComplete,
} from './rastreamento'

// === CONVERSÕES GOOGLE ADS ===
export {
  BIOMO_ADS_ID,
  BIOMO_CONVERSIONS,
  THIAGO_ADS_ID,
  THIAGO_CONVERSIONS,
  GOOGLE_ADS_ACCOUNTS,
  GOOGLE_ADS_ID,
  CONVERSIONS,
  trackConversion,
  trackWhatsAppClick,
  trackFormCompleted,
  trackLeadRegistered,
} from './conversoes'

// === COLETA COMPLETA ===
import type { AnalyticsData } from './tipos'
import { getUTMParams } from './utm'
import { getReferrerInfo, getSessionInfo, getPreferencesInfo } from './sessao'
import { getDeviceInfo } from './dispositivo'
import { fetchGeoInfo } from './geo'

/**
 * Coleta todos os dados de analytics de uma vez
 */
export async function collectAllAnalytics(formStartTime?: number): Promise<AnalyticsData> {
  const [geoInfo] = await Promise.all([fetchGeoInfo()])

  return {
    utm: getUTMParams(),
    referrer: getReferrerInfo(),
    device: getDeviceInfo(),
    geo: geoInfo,
    session: getSessionInfo(formStartTime),
    preferences: getPreferencesInfo(),
  }
}

/**
 * Inicializa analytics (chamar no mount)
 */
export function initAnalytics(): void {
  if (typeof window === 'undefined') return
  getUTMParams()
  getReferrerInfo()
  getSessionInfo()
}
